import { LOADER_STATUS, PROFILE_DATA,SET_ENTITY_LIST } from "./constants";

export const initialState = {
  loaderStatus: false,
  profileData:[],
  entityMasterList:[]
};

const fileGstr7DataReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
        case PROFILE_DATA:
          return {
            ...state,
            profileData:action.profileData
          }
        case SET_ENTITY_LIST:
          return {
            ...state,
            entityMasterList:action.payload
          }
      default:
        return state; 
    }
  };

export default fileGstr7DataReducer;
